"use strict";
(function ($) {
    $(".bol-service__status_content h2").each(function () {
        if ($(this).html() == "Normal Service") {
            $(this).parent().parent().parent().addClass("normal");
        }
        if ($(this).html() == "Partial Service") {
            $(this).parent().parent().parent().addClass("partial");
        }
        if ($(this).html() == "Interrupted Service") {
            $(this).parent().parent().parent().addClass("interrupted");
        }
    });
})(jQuery);
